module.exports = __webpack_public_path__ + "static/elder-warden-717f4387bba199ec88a66e5aca1b88e3.png";